import { GoogleRMKT, GoogleSiteTag } from "./providers/google";
import Facebook from "./providers/facebook";
import Adobe from "./providers/adobe";
import * as MUTATIONS from "../config/constants/mutation-types";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      landing: [
        "GoogleRMKT.landing",
        "GoogleSiteTag.landing",
        "Facebook.landing",
        "Adobe.landing"
      ],
      paso1: [
        "GoogleRMKT.paso1",
        "GoogleSiteTag.paso1",
        "Facebook.paso1",
        "Adobe.paso1"
      ],
      paso2: [
        "GoogleRMKT.paso2",
        "GoogleSiteTag.paso2",
        "Facebook.paso2",
        "Adobe.paso2"
      ],
      paso3: [
        "GoogleRMKT.paso3",
        "GoogleSiteTag.paso3",
        "Facebook.paso3",
        "Adobe.paso3"
      ],
      paso4: [
        "GoogleRMKT.paso4",
        "GoogleSiteTag.paso4",
        "Facebook.paso4",
        "Adobe.paso4"
      ],
      gracias: [
        "GoogleRMKT.gracias",
        "GoogleSiteTag.gracias",
        "Facebook.gracias",
        "Adobe.gracias"
      ],
      mensaje: [
        "GoogleRMKT.mensaje",
        "GoogleSiteTag.mensaje",
        "Facebook.mensaje",
        "Adobe.mensaje"
      ]
    },
    [MUTATIONS.ADOBE_APP_STARTED]: ["Adobe.appStartedClick"],
    [MUTATIONS.ADOBE_APP_ON_CLICK_START]: ["Adobe.appOnClickStart"]
  },
  providers: {
    GoogleRMKT,
    GoogleSiteTag,
    Facebook,
    Adobe
  }
};

export default pixelDb;
